import Vue from 'vue'
import Vuex from 'vuex'

import moles from './moles'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    moles: moles,
    user: user,
  },
})
